/* global AFRAME */

/**
 * Component that listens to an event, fades out an entity, swaps the texture, and fades it
 * back in.
 */
  
 
 
 
AFRAME.registerComponent('translate-object', {
  schema: {
    on: {type: 'string'},
    target: {type: 'selector'},
    src: {type: 'string'},
    dur: {type: 'number', default: 300},
	offset: {type: 'number', default: 0},
	defaultY: {type: 'number', default: 0},
	defaultZ: {type: 'number', default: 0},
	yfactor: {type: 'number', default: 1},
	interval: {type: 'number', default: 1}
  },
  
  init: function () {
	
	this.data.defaultY = this.el.object3D.position.y;
	this.data.defaultZ = this.el.object3D.position.z;
  },
  

  tick: function () {
	
	global_webvr_adidas.lastUpdate
	
	var now = Date.now();
	var dt = now - global_webvr_adidas.lastUpdate;
	global_webvr_adidas.lastUpdate = now;
	var data = this.data;
	
	global_webvr_adidas.timer += (dt / 5000);
	
	var translationY = data.yfactor * Math.sin((global_webvr_adidas.timer + data.offset) * data.interval)
	var translationZ = data.yfactor * 2 * Math.sin((global_webvr_adidas.timer - data.offset) * data.interval)
	this.el.object3D.position.y = data.defaultY + translationY;
	this.el.object3D.position.z = data.defaultZ + translationZ;
  }
  
  
  
  
});
